export const DEFAULT_ERROR_MESSAGE = 'Something went wrong (code: c1)';
